import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import EditDynamicSectionForm from '../EditDynamicSectionForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'

export default function EditDynamicSectionListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`แก้ไขการตั้งค่า Section`}
					description="แก้ไขการตั้งค่า Section"
				/>
				<NavigateBackButton />
			</div>
			<Separator />
			<EditDynamicSectionForm />
		</div>
	)
}
